module.exports = __webpack_public_path__ + "static/media/starfighter-alt.f129d4a9.svg";